import React, { PropTypes } from 'react';
import Header from '../../ClubCmsHeader';
// import FlatButton from 'material-ui/FlatButton';
import ClubCmsAddHeader from '../../ClubCmsAddHeader';
import TwoColumnsContent from './TwoColumnsContent';
// import {TYPE_TRANSFERS_CONTENT} from "../../../../api/club-cms/constants";

class TwoColumnsComponent extends React.Component {
  static propTypes = {
    node: PropTypes.object,
    onUpdateContent: PropTypes.func.isRequired,
    updateHeaderTwoLabel: PropTypes.func.isRequired,
    addHeaderTwo: PropTypes.func.isRequired
  };


  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  _getContentType() {
    return this.props.node.children.first()
      .children.first()
      .type;
  }

  render() {
    let {node, addHeaderTwo, onUpdateContent, removeHeaderTwo } = this.props;

    const {
      baseTheme: {palette: { primary1Color }}
    } = this.context.muiTheme;
    return (
      <div>
        {node.children.map(
          (headerTwo) => (
            <Header
              label={headerTwo.label} color={primary1Color}
              onChangeLabel={(label) => this.props.updateHeaderTwoLabel(headerTwo, label)}
              canDelete={node.children.size > 1}
              remove={() => removeHeaderTwo(headerTwo)}
            >
              {headerTwo.children.map(
                (content, index) => (
                  <TwoColumnsContent
                    key={index}
                    content={content}
                    changeContent={onUpdateContent}
                  />
                )
              )}
              {/*<FlatButton label="Add 2 column content" onClick={() => addContent(headerTwo, TYPE_TRANSFERS_CONTENT)} />*/}
            </Header>
          )
        )}
        <ClubCmsAddHeader label="Add Title" onClick={() => addHeaderTwo(this._getContentType())} color={primary1Color}/>
      </div>
    );
  }
}

export default TwoColumnsComponent;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/TwoColumnContent/index.js